import { IonContent, IonPage, useIonToast, IonFooter } from '@ionic/react';
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";

import Header from "src/components/Header";
import Dialog from "src/components/Dialog";
import SimpleList from "src/components/SimpleList";
import Spinner from "src/components/Spinner";

import MarcacionAPI from "src/services/marcacion";
import LocationAPI from "src/services/location";

import { distanciaEntreCoordenadas } from "src/utils/coordenadas";
import { formatearFecha } from "src/utils/fechas";
import { Marcacion, Posicion } from "src/utils/interfaces";

const Marcaciones: React.FC = () => {
  const [posicion, setPosicion] = useState<Posicion | undefined>(undefined);
  const [marcaciones, setMarcaciones] = useState<Marcacion[]>([]);
  const [solicitudEnProceso, setSolicitudEnProceso] = useState<boolean>(false);
  const [verConfirmacion, setVerConfirmacion] = useState<boolean>(false);
  const [tituloConfirmacion, setTituloConfirmacion] = useState<string>("");
  const [mensajeConfirmacion, setMensajeConfirmacion] = useState<JSX.Element>(
    <span></span>
  );
  const [present] = useIonToast();

  // cada vez que entramos a la vista, precargamos los datos
  useEffect(() => {
    cargarMarcaciones();
  }, []);

  const cargarMarcaciones = async () => {
    if (solicitudEnProceso) return;
    setSolicitudEnProceso(true);

    LocationAPI.getLocation()
      .then((posicion) => {
        const longitud = posicion.coords.longitude;
        const latitud = posicion.coords.latitude;
        setPosicion({ latitud, longitud });
        MarcacionAPI.puntoDeServicioCercanos(latitud, longitud)
          .then((response) => {
            const registros = response.data.datos.map((punto: Marcacion) => ({
              ps_codigo: punto.ps_codigo,
              ps_nombre: punto.ps_nombre,
              distancia: distanciaEntreCoordenadas(
                latitud,
                longitud,
                punto.ps_latitud,
                punto.ps_longitud
              ),
            }));
            localStorage.setItem('Latitud', latitud.toString())
            
            localStorage.setItem('Longitud', longitud.toString())
            const registrosOrdenados = registros.sort((a: any, b: any) =>
              a.ps_nombre > b.ps_nombre ? 1 : -1
            );

            setMarcaciones(registrosOrdenados);
          })
          .catch((error) => {
            // presentamos el error con un Toast
            present({
              message: error.response ? error.response.data.error : error,
              duration: 5000,
            });
          });
      })
      
      .catch(() => {
        present({
          message: "Ocurrió un error al cargar tu ubicación",
          duration: 5000,
        });
      })
      .finally(() => setSolicitudEnProceso(false));
  };

  const marcacionesAListItems = (marcaciones: Marcacion[]) => {
    return marcaciones.map((marcacion) => {
      const mensajeDistancia =
        marcacion.distancia === 1
          ? `Estas a ${Math.floor(marcacion.distancia)} metro`
          : `Estas a unos ${Math.floor(marcacion.distancia)} metros`;

      return {
        id: marcacion.ps_codigo,
        title: marcacion.ps_nombre,
        subtitle: mensajeDistancia,
        options: [
          {
            text: "Marcar Entrada",
            action: () => marcarEntrada(marcacion),
          },
          {
            text: "Marcar Salida",
            action: () => marcarSalida(marcacion),
          },
        ],
      };
    });
  };

  const marcarEntrada = (marcacion: Marcacion) => {
    if (!posicion) return;

    MarcacionAPI.marcarEntrada(marcacion.ps_codigo, posicion)
      .then((response) => {
        mostrarResultadosDeMarcacion(marcacion.ps_nombre, response.data);
      })
      .catch((error) => {
        present({
          message: error.response ? error.response.data.error : error,
          duration: 5000,
        });
      });
  };

  const marcarSalida = (marcacion: Marcacion) => {
    if (!posicion) return;

    MarcacionAPI.marcarSalida(marcacion.ps_codigo, posicion)
      .then((response) => {
        mostrarResultadosDeMarcacion(marcacion.ps_nombre, response.data);
      })
      .catch((error) => {
        present({
          message: error.response ? error.response.data.error : error,
          duration: 5000,
        });
      });
  };

  const mostrarResultadosDeMarcacion = (nombre: string, data: any) => {
    const titulo = `${data.accion} exitosa`;

    const fechaMarcacion = formatearFecha(new Date(data.fecha_marcacion));
    const [horas, minutos] = data.hora_marcacion.split(":");
    const horaMarcacion = `${horas}:${minutos}`;

    const mensaje = (
      <div className="body-1 color-light-grey">
        <p className="mt-0">
          Marcaste {data.accion} en {nombre} el día {fechaMarcacion} a las{" "}
          {horaMarcacion}.
        </p>
        <p className="mb-0">Código de marcación: {data.id_marcacion}.</p>
      </div>
    );

    setTituloConfirmacion(titulo);
    setMensajeConfirmacion(mensaje);
    setVerConfirmacion(true);
  };
  const simpleListItems = marcacionesAListItems(marcaciones);
  const latitud = localStorage.getItem('Latitud')
  const longitud = localStorage.getItem('Longitud')
  return (
    <IonPage>
      <Header titulo="Marcación" />

      <IonContent id="reclamos">
        <div className="container mt-3">
          {simpleListItems.length === 0 && !solicitudEnProceso ? (
            <span>No se encontraron Ubicaciones cercanos.</span>
          ) : (
            <SimpleList items={simpleListItems} />
          )}

          <Spinner activo={solicitudEnProceso} texto="Cargando..." />
        </div>

        <Dialog
          open={verConfirmacion}
          title={tituloConfirmacion}
          message={mensajeConfirmacion}
          setOpen={setVerConfirmacion}
        />
      </IonContent>
      <IonFooter class='footer'>
        <div className="container">
           <p>Su ubicacion actual es {latitud}, {longitud} </p> </div>
      </IonFooter>
    </IonPage>
  );
  
};

export default withRouter(Marcaciones);
